import { get, post,put } from "../Config";

// GET
export function CollectPointHistoryList({ params }) {
  return get({ url: `/api/koala/v1/point-history`, params });
}